module.exports = __webpack_public_path__ + "static/iphone_wireframes-de573ee992b476d29549e01e3ffe92ac.jpg";